import * as styles from '../Button.css';
var BUTTON_THEMES_MAP = new Map([['default', styles['button--default']], ['fsk', styles['button--fsk']], ['pik', styles['button--pik']]]);
export var getButtonThemeClass = function getButtonThemeClass(theme) {
  return theme && BUTTON_THEMES_MAP.get(theme) || styles['button--default'];
};